<!-- Action Buttons -->
<div class="d-flex gap-3 align-items-center">
    @if(showSubmit){
        <app-primary-button [label]="searchLabel" [isDisabled]="isSubmitDisabled" [isLoading]="isSubmitLoading" (handleClick)="search()"></app-primary-button>
    }
    @if(showDiscard){
        <app-text-button [label]="discardLabel" [isDisabled]="isDiscardDisabled" (handleClick)="discard()" [textColorClass]="'color-danger'"></app-text-button>
    }

</div>
